import { render, staticRenderFns } from "./MergeMaterialEdit.vue?vue&type=template&id=8025062c&scoped=true&"
import script from "./MergeMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./MergeMaterialEdit.vue?vue&type=script&lang=js&"
import style0 from "./MergeMaterialEdit.vue?vue&type=style&index=0&id=8025062c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8025062c",
  null
  
)

export default component.exports